module.exports = "/_next/static/images/game-1-intro-tutorial-victim-6778fa72e5c3fe51e58e6dd358c51d47.jpg";